/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import styles from './CategoryTable.module.scss';

import { CategoryTableProps, FieldType } from './CategoryTable.types';

const TYPE_CLASS: Record<FieldType, string> = {
  text: styles.typeText,
  alnum: styles.typeAlnum,
  curr: styles.typeCurr,
  date: styles.typeDate,
  int: styles.typeInt,
  dec: styles.typeInt,
  pct: styles.typePct,
  bool: styles.typeBool,
  url: styles.typeUrl,
  arr: styles.typeBool,
  obj: styles.typeBool,
};

export const CategoryTable = ({ id, title, count, color, icon, fields }: CategoryTableProps) => {
  const { t } = useInt();

  return (
    <section id={id} className={styles.panel}>
      <div className={styles.head}>
        <span className={cn(styles.icon, styles[`icon${color[0].toUpperCase()}${color.slice(1)}`])}>{icon}</span>
        <h2 className={styles.title}>{title}</h2>
        <span className={styles.pill}>
          {count} {t('fields')}
        </span>
      </div>

      <div className={styles.tableWrap}>
        <div className={styles.scroll}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>{t('Field Name')}</th>
                <th>{t('Description')}</th>
                <th>{t('Type')}</th>
                <th>{t('Example')}</th>
              </tr>
            </thead>
            <tbody>
              {fields.map((field) => (
                <tr key={field.name}>
                  <th scope="row">{field.name}</th>
                  <td>{field.description}</td>
                  <td>
                    <span className={cn(styles.type, TYPE_CLASS[field.type])}>{field.typeLabel}</span>
                  </td>
                  <td className={styles.example}>{field.example}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};
